import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:image:width",
  content: 335
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:image:height",
  content: 335
}, null, -1)
const _hoisted_4 = ["content"]
const _hoisted_5 = ["content"]
const _hoisted_6 = {
  id: "body",
  class: "template_offerlist"
}
const _hoisted_7 = { class: "page-header" }
const _hoisted_8 = { class: "width-wrap" }
const _hoisted_9 = {
  key: 0,
  class: "width-wrap"
}
const _hoisted_10 = { class: "estate-agent" }
const _hoisted_11 = { class: "estate-agent__content" }
const _hoisted_12 = { class: "estate-agent__name" }
const _hoisted_13 = { class: "estate-agent__company-position" }
const _hoisted_14 = {
  key: 0,
  class: "estate-agent__rating"
}
const _hoisted_15 = { class: "estate-agent__info" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "estate-agent__lang"
}
const _hoisted_18 = {
  key: 1,
  class: "estate-agent__contact"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 2,
  class: "buttons-inline"
}
const _hoisted_22 = { class: "estate-agent__aside" }
const _hoisted_23 = { class: "estate-agent__photo" }
const _hoisted_24 = {
  key: 0,
  class: "estate-agent__company-logo"
}
const _hoisted_25 = { class: "section section--map" }
const _hoisted_26 = { class: "width-wrap section-header" }
const _hoisted_27 = { class: "map" }
const _hoisted_28 = { class: "loading" }
const _hoisted_29 = {
  key: 0,
  class: "width-wrap"
}
const _hoisted_30 = { class: "section section--rating" }
const _hoisted_31 = { class: "section-header" }
const _hoisted_32 = { class: "rating__count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_EstateAgentReviewStars = _resolveComponent("EstateAgentReviewStars")!
  const _component_EstateAgentLanguage = _resolveComponent("EstateAgentLanguage")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_ReadMore = _resolveComponent("ReadMore")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdOfferList = _resolveComponent("AdOfferList")!
  const _component_vue_progress_bar = _resolveComponent("vue-progress-bar")!
  const _component_MapSearch = _resolveComponent("MapSearch")!
  const _component_EstateAgentReviewStarsList = _resolveComponent("EstateAgentReviewStarsList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.title')) + " " + _toDisplayString(_ctx.estateAgent.fullName), 1),
        _createElementVNode("meta", {
          property: "og:image",
          content: _ctx.image
        }, null, 8, _hoisted_1),
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("meta", {
          name: "description",
          content: _ctx.estateAgent.metaDescription
        }, null, 8, _hoisted_4),
        _createElementVNode("meta", {
          property: "og:description",
          content: _ctx.estateAgent.metaDescription
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.title')) + " " + _toDisplayString(_ctx.estateAgent.fullName), 1)
        ])
      ]),
      (_ctx.estateAgent && _ctx.estateAgent.frontUserId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.estateAgent.fullName), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.position')), 1),
                (!_ctx.isEstateAgencyMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_EstateAgentReviewStars, {
                        rating: _ctx.estateAgent.reviewRating
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToReviews && _ctx.scrollToReviews(...args))),
                            class: "rating__count"
                          }, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.rating-count', { count: _ctx.estateAgent.reviewCount })), 1)
                        ]),
                        _: 1
                      }, 8, ["rating"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (!_ctx.isEstateAgencyMode)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.year-created')) + " " + _toDisplayString(_ctx.estateAgent.yearCreated), 1))
                    : _createCommentVNode("", true),
                  (_ctx.estateAgent.languages && _ctx.estateAgent.languages.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.languages')) + ":", 1),
                        _createVNode(_component_EstateAgentLanguage, {
                          languages: _ctx.estateAgent.languages
                        }, null, 8, ["languages"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isLoggedIn || _ctx.isEstateAgencyMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("a", {
                        href: `tel:${_ctx.estateAgent.phoneNumber}`
                      }, _toDisplayString(_ctx.estateAgent.phoneNumber), 9, _hoisted_19),
                      _createElementVNode("a", {
                        href: `mailto:${_ctx.estateAgent.email}`
                      }, _toDisplayString(_ctx.estateAgent.email), 9, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isLoggedIn || _ctx.estateAgent.reviewCount > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (!_ctx.isLoggedIn && !_ctx.isEstateAgencyMode)
                        ? (_openBlock(), _createBlock(_component_LoginButton, {
                            key: 0,
                            text: _ctx.$t('EstateAgentPublicProfile.show-contact'),
                            buttonClass: "button button--primary"
                          }, null, 8, ["text"]))
                        : _createCommentVNode("", true),
                      (_ctx.estateAgent.reviewCount > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "button button--primary reversed",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollToReviews && _ctx.scrollToReviews(...args)))
                          }, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.scroll-to-reviews')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ReadMore, {
                  class: "estate-agent__description",
                  text: _ctx.estateAgent.description,
                  textEn: _ctx.estateAgent.descriptionEn,
                  isTranslateEnabled: true,
                  onTranslate: _ctx.translate,
                  max: 200,
                  moreText: _ctx.$t('EstateAgentPublicProfile.show-more'),
                  lessText: _ctx.$t('EstateAgentPublicProfile.show-less')
                }, null, 8, ["text", "textEn", "onTranslate", "moreText", "lessText"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_ResizableImage, {
                    url: _ctx.estateAgent.photoRelativeUrl,
                    placeholder: "img/no-photo-user.png",
                    width: 335,
                    height: 335,
                    alt: _ctx.estateAgent.fullName
                  }, null, 8, ["url", "alt"])
                ]),
                (_ctx.estateAgent.estateAgencyUrlName && !_ctx.isEstateAgencyMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        to: { name: 'AdAgencyList', params: { urlName: _ctx.estateAgent.estateAgencyUrlName } }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ResizableImage, {
                            classes: "estate-agency-logo",
                            url: _ctx.estateAgent.logoRelativeUrl,
                            placeholder: "img/no-logo-agency.png",
                            width: 200,
                            height: 112.5
                          }, null, 8, ["url"])
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_ReadMore, {
                class: "estate-agent__slogan",
                text: _ctx.estateAgent.motto,
                textEn: _ctx.estateAgent.mottoEn,
                isTranslateEnabled: true,
                max: 20000,
                onTranslate: _ctx.translateMotto
              }, null, 8, ["text", "textEn", "onTranslate"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.estateAgent.frontUserId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_AdOfferList, {
              mode: _ctx.mode,
              frontUserId: _ctx.estateAgent.frontUserId
            }, null, 8, ["mode", "frontUserId"]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.map-header')), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_vue_progress_bar, { class: "progress-bar" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.map-loading')), 1)
                ], 512), [
                  [_vShow, _ctx.RADON_LOADING_BAR.options.show]
                ]),
                _createVNode(_component_MapSearch, {
                  ref: "map",
                  ads: _ctx.markers,
                  polylines: _ctx.polylines,
                  bounds: _ctx.bounds,
                  zoom: _ctx.zoom,
                  onBoundsChanged: _ctx.onBoundsChanged,
                  onSelected: _ctx.onMapSelected
                }, null, 8, ["ads", "polylines", "bounds", "zoom", "onBoundsChanged", "onSelected"])
              ])
            ]),
            (!_ctx.isEstateAgencyMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.agent-review')) + " " + _toDisplayString(_ctx.estateAgent.fullName), 1)
                    ]),
                    _createVNode(_component_EstateAgentReviewStars, {
                      rating: _ctx.estateAgent.reviewRating
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('EstateAgentPublicProfile.rating-count', { count: _ctx.estateAgent.reviewCount })), 1)
                      ]),
                      _: 1
                    }, 8, ["rating"]),
                    _createVNode(_component_EstateAgentReviewStarsList, {
                      frontUserId: _ctx.estateAgent.frontUserId
                    }, null, 8, ["frontUserId"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}